<template>
  <v-card
    rounded="md"
    :href="link"
    @click="handleLink"
    elevation="2"
    class="proposal-img"
    v-intersect.once="handleView"
  >
    <v-img :src="src" :alt="proposal.name" />
  </v-card>
</template>
<script>
import banner from "~/mixins/banner";
import get from "lodash/get";
import clickHandler from "~/mixins/clickHandler";

export default {
  name: "ProposalImage",
  props: {
    proposal: { type: Object, required: true }
  },
  mixins: [banner, clickHandler],
  computed: {
    src() {
      let prop =
        "metaData.category_proposal_type." +
        (!this.$vuetify.breakpoint.xsOnly ? "IMAGE_DESKTOP" : "IMAGE_MOBILE");
      return get(this.proposal, prop, this.proposal.img);
    }
  }
};
</script>
